import script from "./SelectOptionDisabledBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectOptionDisabledBlock.vue?vue&type=script&setup=true&lang=js"

import "./SelectOptionDisabledBlock.vue?vue&type=style&index=0&id=b41c2cd4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b41c2cd4"]])

export default __exports__